'use client';

import { installJsonConsoleLogger } from '@/shared/logging/json-logger-installer';
import { getFrontendRuntimeConfig } from '@/shared/api/frontend-runtime-config-client';
import { useEffect } from 'react';

/**
 * 브라우저 런타임의 console 출력을 운영자 확인용 텍스트 형식으로 전환합니다.
 */
export function BrowserJsonLoggerInstaller() {
  useEffect(() => {
    installJsonConsoleLogger({ runtime: 'browser' });
    void getFrontendRuntimeConfig().catch(() => {
      /* 런타임 설정 조회 실패 시 기본 마스킹 정책을 유지합니다. */
    });
  }, []);

  return null;
}
